import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBJi7bSzrDCqIO7GvXZBq9bP-f5UgdxbUI",
  authDomain: "pustakvari-c383d.firebaseapp.com",
  projectId: "pustakvari-c383d",
  storageBucket: "pustakvari-c383d.appspot.com",
  messagingSenderId: "545456813420",
  appId: "1:545456813420:web:ef4d90c167a49e9e0f2f49",
};

initializeApp(firebaseConfig);

const messaging = getMessaging();

export const requestToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const currentToken = await getToken(messaging, {
        vapidKey:
          "BGuA41LpkRWSWqFrOtPQPRiHHdSw0FIPHHtG9IPiRF6WMCdAStX1gN4xge1BIiCqvvEWPf8y7I69GklEV-7ASkg",
      });
      if (currentToken) {
        return currentToken; // Return the token
      } else {
        console.log("No registration token available.");
        return null; // Return null if token is not available
      }
    } else {
      console.log("Notification permission denied.");
      return null; // Return null if permission is denied
    }
  } catch (error) {
    console.error("An error occurred while retrieving token:", error);
    return null; // Return null if an error occurs
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
